<template>
  <div class="recaptcha-container border p-3 mb-5 rounded">
    <div v-if="!isVerifiedCaptcha">
      <div class="form-check mb-3">
        <input id="verifyCheckbox" v-model="checkboxChecked" class="form-check-input" type="checkbox" value="" />
        <label class="form-check-label fs-3 fw-lighter" for="verifyCheckbox">I am not a robot</label>
      </div>
      <div class="drag-box border rounded p-2 mb-3" @drop.prevent="handleDrop" @dragover.prevent>
        <p v-if="!dragCompleted" class="text-center m-0">Drag the circle to the box below</p>
        <p v-else class="text-center text-success m-0">Drag Completed!</p>
      </div>
      <div class="draggable-circle border rounded-circle bg-primary" draggable="true" @dragstart="startDragging"></div>
    </div>
    <div v-else>
      <p class="text-success">Verification complete! You are human.</p>
    </div>
  </div>
</template>

<script lang="ts">
import { Vue, Component, Ref } from 'vue-facing-decorator';

@Component({
  // Declare components if needed, e.g., other components
})
@Component
export default class RecaptchaComponent extends Vue {
  @Ref() checkboxChecked!: boolean;
  @Ref() dragCompleted!: boolean;
  @Ref() isDragging!: boolean;
  @Ref() isVerified!: boolean;

  get isVerifiedCaptcha() {
    return this.checkboxChecked && this.dragCompleted;
  }

  startDragging() {
    this.isDragging = true;
  }

  handleDrop() {
    if (this.isDragging) {
      this.dragCompleted = true;
      this.isDragging = false;
    }
  }

  submitCaptcha() {
    alert('Captcha submitted successfully!');
  }
}
</script>

<style scoped>
.recaptcha-container {
  width: 300px;
  background-color: #f8f9fa;
}
.drag-box {
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.draggable-circle {
  width: 40px;
  height: 40px;
  cursor: grab;
}
.custom-rounded {
  border-radius: 0.25rem !important;
}
.form-check-input {
  margin-top: 5px;
  margin-right: 15px;
  width: 20px;
  height: 20px;
}
</style>
